import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../axios";

export const searchApi = createAsyncThunk(
  "search/suggest",
  async ({ q } = {}, { rejectWithValue }) => {
    if (!q || !q.trim()) {
      return rejectWithValue({
        success: false,
        message: "Search query is required",
      });
    }
    try {
      const response = await axios.get("/search", {
        params: { q: q.trim() },
      });
      return response.data; // { success, data: [...] }
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue({
        success: false,
        message: "Failed to fetch search results",
      });
    }
  },
);
